"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment PersonalEditorialArticlePage on Application {\n    personalEditorialPage(pageId: $pageId) {\n      pageId\n      contentItems {\n        ...EditorialContent\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.personalEditorialArticlePageFragment = void 0;
var _fetching = require("@ori/fetching");
var _editorialArticlePageFragment = require("./editorialArticlePageFragment");
const personalEditorialArticlePageFragment = exports.personalEditorialArticlePageFragment = (0, _fetching.gql)(_templateObject(), _editorialArticlePageFragment.editorialContentTypesFragment);
